import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { PlansService } from '../services/plans.service';

export const PlansResolver: ResolveFn<any> = (
  route?: ActivatedRouteSnapshot,
  state?: RouterStateSnapshot,
  plansService: PlansService = inject(PlansService)
): Promise<any> => {
  const scope = route.data['scope'];
  return new Promise((resolve: any) => {
    resolve(plansService.loadBasePlansCache(scope));
  });
};
